import { InvoiceStatus, PaymentStatus } from 'src/constants';

export const isPaymentStatus = (status: InvoiceStatus | PaymentStatus) => {
  return Object.values<PaymentStatus | InvoiceStatus>(PaymentStatus).includes(status);
};
